/* La Ronde - header nav toggle and hero cross-fade carousel. */
(function () {
  if (!customElements.get('lr-header-nav')) {
    customElements.define('lr-header-nav', class extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-lr-nav-toggle]');
        this.nav = this.querySelector('[data-lr-nav]');
        if (!this.toggle || !this.nav) return;
        this.toggle.addEventListener('click', () => {
          const open = this.toggle.getAttribute('aria-expanded') !== 'true';
          this.toggle.setAttribute('aria-expanded', String(open));
          this.nav.classList.toggle('is-open', open);
        });
      }
    });
  }

  if (!customElements.get('lr-carousel')) {
    customElements.define('lr-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-lr-slide]')];
        this.dots = [...this.querySelectorAll('[data-lr-dot]')];
        this.pauseBtn = this.querySelector('[data-lr-carousel-pause]');
        this.status = this.querySelector('[data-lr-carousel-status]');
        this.index = 0;
        this.delay = (parseInt(this.dataset.interval, 10) || 6) * 1000;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.paused = this.reduced;
        if (this.slides.length < 2) return;

        this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i, true); this.restart(); }));
        if (this.pauseBtn) {
          if (this.reduced) this.setPaused(true);
          this.pauseBtn.addEventListener('click', () => { this.setPaused(!this.paused); });
        }
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.restart());
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.findIndex((s) => s.contains(e.target) || s === e.target);
          if (i > -1) { this.setPaused(true); this.go(i, false); }
        });
        this.restart();
      }
      disconnectedCallback() { this.stop(); }
      go(i, announce) {
        this.index = (i + this.slides.length) % this.slides.length;
        this.slides.forEach((s, n) => {
          const on = n === this.index;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', String(!on));
        });
        this.dots.forEach((d, n) => d.setAttribute('aria-current', String(n === this.index)));
        if (announce && this.status) this.status.textContent = `Image ${this.index + 1} of ${this.slides.length}`;
      }
      setPaused(p) {
        this.paused = p;
        if (this.pauseBtn) {
          this.pauseBtn.setAttribute('aria-pressed', String(p));
          this.pauseBtn.textContent = p ? this.pauseBtn.dataset.playLabel : this.pauseBtn.dataset.pauseLabel;
        }
        p ? this.stop() : this.restart();
      }
      stop() { clearInterval(this.timer); this.timer = null; }
      restart() {
        this.stop();
        if (this.paused) return;
        this.timer = setInterval(() => this.go(this.index + 1, false), this.delay);
      }
    });
  }
})();

/* Product page - gallery thumbnails, option chips to variant, quantity, recommendations. */
(function () {
  const money = (cents) => {
    const fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
    try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: fmt }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  if (!customElements.get('lr-product-form')) {
    customElements.define('lr-product-form', class extends HTMLElement {
      connectedCallback() {
        const json = this.querySelector('[data-lr-variants]');
        this.variants = json ? JSON.parse(json.textContent) : [];
        this.main = this.querySelector('[data-lr-gallery-main]');
        this.thumbs = [...this.querySelectorAll('[data-lr-thumb]')];
        this.idInput = this.querySelector('[data-lr-variant-id]');
        this.price = this.querySelector('[data-lr-price]');
        this.add = this.querySelector('[data-lr-add]');
        this.qty = this.querySelector('input[name="quantity"]');

        this.thumbs.forEach((t) => t.addEventListener('click', () => this.showMedia(t)));
        this.querySelectorAll('[data-lr-option]').forEach((r) => r.addEventListener('change', () => this.onOptionChange()));
        this.querySelectorAll('[data-lr-qty]').forEach((b) => b.addEventListener('click', () => {
          if (!this.qty) return;
          const next = Math.max(1, (parseInt(this.qty.value, 10) || 1) + parseInt(b.dataset.lrQty, 10));
          this.qty.value = next;
        }));
      }
      showMedia(thumb) {
        if (!thumb || !this.main) return;
        this.main.src = thumb.dataset.src;
        this.main.srcset = thumb.dataset.srcset;
        this.main.alt = thumb.dataset.alt;
        this.thumbs.forEach((t) => {
          const on = t === thumb;
          t.classList.toggle('is-active', on);
          on ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current');
        });
      }
      onOptionChange() {
        const groups = {};
        this.querySelectorAll('[data-lr-option]:checked').forEach((r) => { groups[r.dataset.lrOption] = r.value; });
        this.refreshAvailability(groups);
        const variant = this.variants.find((v) => v.options.every((val, i) => groups[i + 1] === undefined || groups[i + 1] === val));
        if (!variant) {
          this.setButton(false, 'unavailable');
          return;
        }
        this.idInput.value = variant.id;
        if (this.price) {
          this.price.innerHTML = (variant.compare_at_price > variant.price ? `<s>${money(variant.compare_at_price)}</s>` : '') + money(variant.price);
        }
        this.setButton(variant.available, variant.available ? 'add' : 'soldout');
        if (variant.featured_media) {
          const t = this.thumbs.find((x) => x.dataset.mediaId === String(variant.featured_media.id));
          if (t) this.showMedia(t);
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      refreshAvailability(groups) {
        this.querySelectorAll('[data-lr-option]').forEach((input) => {
          const pos = parseInt(input.dataset.lrOption, 10);
          const ok = this.variants.some((v) => v.available && v.options.every((val, i) =>
            (i + 1 === pos ? val === input.value : (groups[i + 1] === undefined || groups[i + 1] === val))));
          const chip = input.closest('.lr-chip');
          if (chip) chip.classList.toggle('is-unavailable', !ok);
        });
      }
      setButton(enabled, state) {
        if (!this.add) return;
        this.add.disabled = !enabled;
        this.add.textContent = this.add.dataset['label' + state.charAt(0).toUpperCase() + state.slice(1)];
      }
    });
  }

  if (!customElements.get('lr-related')) {
    customElements.define('lr-related', class extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('.lr-products') || !this.dataset.url) return;
        const io = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          fetch(this.dataset.url).then((r) => r.text()).then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const inner = doc.querySelector('lr-related');
            if (inner && inner.innerHTML.trim()) this.innerHTML = inner.innerHTML;
          }).catch(() => {});
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(this);
      }
    });
  }
})();
